import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientMarketingApiAdapter, type UpdateMarketingLangPayload } from '../adapters/ClientMarketingApiAdapter';

export const useUpdateMarketingLang = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientMarketingApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (payload: UpdateMarketingLangPayload) =>
            apiAdapter.updateMarketingLang(teamId, payload),
        onSuccess: () => {
            // Invalidar la cache del cliente para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        updateMarketingLang: mutation.mutate,
        updateMarketingLangAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

